import { GradientAvatar } from '@/shared/components';
import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import type { Conversation } from '../../models/conversation';
import type { Member } from '../../models/member';

interface ConversationInfoProps {
  conv: Conversation;
  curUser: Member;
  onClose?: () => void;
}

export const ConversationAsideInfo: FC<ConversationInfoProps> = ({ conv, curUser: _curUser, onClose: _onClose }) => {
  return (
    <Stack direction='column' alignItems='center' sx={{ pt: 4 }} gap={2}>
      {/* Group Avatar */}
      <GradientAvatar
        peerId={conv?.conversationId}
        src={conv?.conversationAvatarRef}
        name={conv?.conversationName}
        variant={conv?.conversationType === 'GROUP' ? 'rounded' : 'circular'}
        className='mex:size-20 mex:border mex:border-divider'
      />

      {/* Group Name */}
      <Typography variant='h6' sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
        {conv?.conversationName || 'Cuộc trò chuyện'}
      </Typography>

      {/* Reserved space for future actions */}
      <Stack direction='column' flex={1} className='mex:w-full mex:gap-2 mex:px-2' />
    </Stack>
  );
};
